<template>
    <div>
        <div class="header-return">
            <el-row>
                <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                         :size="GCONFIG.styleElFormSize">
                    <el-form-item label="">
                        <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                    </el-form-item>
                    <el-form-item label="bindCode">
                        <el-input v-model="formInline.bindCode" placeholder="输入bindCode查询"></el-input>
                    </el-form-item>
                    <el-form-item label="发放状态">
                        <el-select v-model="formInline.status" clearable filterable>
                            <el-option
                                    v-for="item in cashStatusList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getList">查询</el-button>
                        <!--<el-button type="success" @click="add()" class="header-btn">新建</el-button>-->
                        <el-button type="primary" @click="downLoad()" class="header-btn">下载导入模板</el-button>
                        <el-button type="success" @click="importData()" class="header-btn">导入</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
        </div>
        <el-table :data="list" stripe border center :size="GCONFIG.styleTableSize">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="标识" prop="id"></el-table-column>
            <el-table-column label="批次名称" prop="ticketBatchName"></el-table-column>
            <el-table-column label="bindCode" prop="bindCode"></el-table-column>
            <el-table-column label="活动名称" prop="activeName"></el-table-column>
            <el-table-column label="状态" prop="sendStatusName"></el-table-column>
            <el-table-column label="昵称" prop="nickName"></el-table-column>
            <el-table-column label="头像" prop="headImageUrl">
                <template slot-scope="scope">
                    <img :src="scope.row.headImageUrl" class="head_pic"/>
                </template>
            </el-table-column>
            <el-table-column label="错误消息" prop="message"></el-table-column>
            <el-table-column label="创建时间" prop="createTime" fixed="right" width="132">
                <template slot-scope="scope">
                    <span>{{formatDate(scope.row.createTime)}}</span>
                </template>
            </el-table-column>
            <!--<el-table-column label="操作" fixed="right" >-->
            <!--<template slot-scope="scope">-->
            <!--<el-button-group>-->
            <!--<el-button type="success" size="mini" @click="edit(scope.row)">编辑</el-button>-->
            <!--<el-button type="danger"  size="mini" @click="handleDel(scope.row)">删除</el-button>-->
            <!--</el-button-group>-->
            <!--</template>-->
            <!--</el-table-column>-->
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="recordsTotal">
            </el-pagination>
        </div>

        <el-dialog title="导入" :visible.sync="importShowDialog">
            <el-row>
                <el-form label-width="120px">
                    <el-form-item label="温馨提醒">
                        <el-alert title="上传操作比较慢，请不要重复操作，如果数据量比较大，建议分多个文件上传(一次建议上传3000条数据)，导入后自动发送券，导入前请先仔细阅读导入excel模板提示 可通过bindCode查询导入记录数" type="success" :closable="false">
                        </el-alert>
                    </el-form-item>
                    <el-form-item label="选择文件">
                        <el-upload
                                multiple
                                :with-credentials="true"
                                :show-file-list="false"
                                class="upload-demo"
                                :before-upload="beforeAvatarUpload"
                                :action="uploadUser"
                                :data="groupData"
                                :on-success="uploadSuccess"
                                :on-progress="uploadProgress"
                        >
                            <el-button size="small" type="primary">{{uploadName}}<i class="el-icon-upload el-icon--right"></i>
                            </el-button>
                        </el-upload>
                    </el-form-item>
                </el-form>
            </el-row>
        </el-dialog>

    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getCashSendLogList, uploadCashLogApi, downLoadCashLogApi
    } from '../../api/api';
    import {getRouterPageHash} from '@/api/http';
    export default {
        data() {
            return {
                showDialog: false,
                list: [],
                recordsTotal: 0,
                formInline: {
                    currentPage: 1,
                    pageSize: 20,
                    bindCode: '',
                    customerId: '',
                    status: 0
                },
                loading: false,
                importShowDialog: false,
                labelShow: false,
                uploadName:'上传',
                uploadUser: uploadCashLogApi,
                cashStatusList: [{value: 0, name: '失败/未发送'}, {value: 1, name: '发送成功'}],
                beforeAvatarUpload(file) {
                    const isLt2M = file.size / 1024 / 1024 < 5;
                    let index = file.name.lastIndexOf(".");
                    let fileName = file.name.substr(index + 1);
                    fileName === 'xls' || fileName === 'xlsx' || fileName === 'cvs';
                    if (!fileName) {
                        this.$message.error('上传只能是excel 格式!');
                    }
                    if (!isLt2M) {
                        this.$message.error('上传大小不能超过 5MB!');
                    }
                    this.loading = true;
                    return fileName && isLt2M;
                }
            }
        },
        created() {

        },
        //挂载时候执行
        mounted(){
            this.getList();
        },
        methods: {
            getList(){
                //查询模板列表
                getCashSendLogList(this.formInline).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.recordsTotal = res.data.value.total;
                        this.list = res.data.value.list;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            add(){
                this.model = {
                    userGroupName: '',
                    groupDesc: '',
                    groupType: 2
                };
                this.showDialog = true;
            },
            edit(row){
                this.model = {
                    id: row.id,
                    userGroupName: row.userGroupName,
                    groupDesc: row.groupDesc,
                    groupType: row.groupType
                };
                this.showDialog = true;
                if (row.groupType == 1) {
                    this.canEditGrouType = true;
                } else {
                    this.canEditGrouType = false;
                }
            },
            save(row){
                //保存应用
                if (this.model.userGroupName == '') {
                    this.$message({
                        message: '组名称不能为空',
                        type: 'error'
                    });
                    return;
                }
                this.loading = true;
                saveGroupApi(this.model).then((res) => {
                    this.loading = false;
                    console.log(res);
                    if (res.data.success) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.showDialog = false;
                });
            },
            handleDel(row){
                //删除
                this.$confirm('删除不可撤销, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteGroupApi({groupId: row.id}).then((res) => {
                        console.log(res);
                        if (res.data.success) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                        this.showDialog = false;
                    });
                })
            },
            handleDelUser(row){
                //删除
                this.$confirm('删除不可撤销, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteUserApi({groupId: row.id}).then((res) => {
                        console.log(res);
                        if (res.data.success) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                        this.showDialog = false;
                    });
                })
            },
            importData(){
                this.importShowDialog = true;
            },
            downLoad(){
                let url = `${downLoadCashLogApi}?pageRouterUrl=${getRouterPageHash(window.location.hash)}`
                window.open(url)
            },
            uploadProgress(event, file, fileList){
                this.loading = true;
                this.uploadName='上传中...请稍后'
            },
            uploadSuccess(response, file, fileList){
                this.loading = false;
                this.importShowDialog = false;
                this.uploadName='上传'
                if (res.status == 500) {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: 'error'
                    });
                }
                if (res.status == 200) {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: 'success'
                    });
                    this.getList();
                }
            },
            formatDate(datetime) {
                if (datetime == null) {
                    return '';
                } else {
                    var date = new Date(datetime);
                    var year = date.getFullYear(),
                        month = ("0" + (date.getMonth() + 1)).slice(-2),
                        sdate = ("0" + date.getDate()).slice(-2),
                        hour = ("0" + date.getHours()).slice(-2),
                        minute = ("0" + date.getMinutes()).slice(-2),
                        second = ("0" + date.getSeconds()).slice(-2);
                    // 拼接
                    var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
                    // 返回
                    return result;
                }
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    .head_pic{
        border-radius: 30px;
        width:132px;
        height:132px;
    }
</style>


// WEBPACK FOOTER //
// src/views/cash/cashSendLog.vue